import type { ComponentChildren, JSX } from 'preact';
import './Button.css';

type Variant = 'primary' | 'secondary' | 'ghost';
type Size = 'sm' | 'md';

interface Props extends Omit<JSX.HTMLAttributes<HTMLButtonElement>, 'size'> {
  variant?: Variant;
  size?: Size;
  children?: ComponentChildren;
}

export function Button({ variant = 'secondary', size = 'md', class: klass, className, children, ...rest }: Props) {
  const classes = ['hv-btn', `hv-btn--${variant}`, `hv-btn--${size}`, klass, className]
    .filter(Boolean)
    .join(' ');
  return (
    <button class={classes} {...rest}>
      {children}
    </button>
  );
}
